import React from 'react';
import { func, string } from 'prop-types';

import IconMarketClose from '@assets/Icon/svg/MarketClose';

import { colors, Container, Row, Col, MessageBox, Typography } from '@ajaibid/components';
import SpecialNotation, { TooltipAcceleratedBoard } from 'Component/SpecialNotation';
import stockService from '@services/stock';

import { useStockBuySellContext } from './hooks';
import { styNotesContainer } from './style';

const StockBuySellNotes = (props) => {
  const { code, onClickTNC } = props;

  const { isLimitOrder, isAutoOrder } = useStockBuySellContext();

  const { data: stockAbout } = stockService.detail.about.useAbout(code);
  const { isMarketClosed } = stockService.global.tradingtime.useTradingTime();

  const isHaveSpecialNotation = stockAbout?.special_notations?.length > 0;
  const isOnAcceleratedBoard = stockAbout?.is_accelerated_board_member;

  return (
    <Container padding="8px 16px 12px" className={styNotesContainer}>
      {isHaveSpecialNotation && (
        <MessageBox type="caution" data-testid="msg-specialNotation">
          <Row noGutters align="between">
            <Col size="auto">Notasi Khusus</Col>
            <Col size="auto">
              <SpecialNotation specialNotation={stockAbout?.special_notations} />
            </Col>
          </Row>
        </MessageBox>
      )}

      {isOnAcceleratedBoard && (
        <MessageBox
          type="info"
          text="Saham ini tercatat dalam Papan Akselerasi"
          icon={<TooltipAcceleratedBoard />}
          data-testid="msg-acceleratedBoard"
        />
      )}

      {isLimitOrder && isMarketClosed && (
        <MessageBox
          type="info"
          text="Di luar jam kerja bursa"
          icon={<IconMarketClose />}
          data-testid="msg-marketClosed"
        />
      )}

      {isAutoOrder && (
        <Typography
          type="body"
          size="xs"
          color={colors.NEUTRAL_7}
          margin={0}
          marginTop={4}
          data-testid="msg-autoOrderTnc"
        >
          Order yang telah diatur akan dikirim ketika syarat terpenuhi, selama Buying Power dan
          jumlah lot mencukupi. Dengan mengaktifkan Auto Order, Anda telah menyetujui&nbsp;
          <Typography
            type="link"
            size="xs"
            style={{ display: 'inline' }}
            onClick={onClickTNC}
            data-testid="btn-autoOrderTnc"
          >
            syarat dan ketentuan
          </Typography>
          &nbsp;fitur Auto Order.
        </Typography>
      )}
    </Container>
  );
};

StockBuySellNotes.propTypes = {
  code: string,
  onClickTNC: func,
};

StockBuySellNotes.defaultProps = {
  code: '',
  onClickTNC: () => {},
};

export default StockBuySellNotes;
